module.exports = __webpack_public_path__ + "img/search.3a715865.svg";